import React from "react";
import "../../css/tp-sect3.css";
import TPSect3Ill from "../../assets/images/teacherPage-sect3-Ill.png";
import { ReactComponent as TPSect3Ic1 } from "../../assets/icons/tp/messages.svg";
import { ReactComponent as TPSect3Ic2 } from "../../assets/icons/tp/edit.svg";
import { ReactComponent as TPSect3Ic3 } from "../../assets/icons/tp/chart.svg";
import { ReactComponent as TPSect3Ic4 } from "../../assets/icons/tp/grid.svg";

const Sect3 = ()=> {
    return(
        <section id="tp-sect3">
            <div>
                <article>
                    <h2>Everything you need to get started</h2>
                    <p>
                        With our integrated CRM, project management, collaboration and invoicing capabilities, 
                        you can manage every aspect of your business in one secure platform.
                    </p>
                </article>
                <div>
                    <div>
                        <div>
                            <span>
                                <TPSect3Ic1 className="tp-s3-ic" />
                            </span>
                            <h3>Updated syllabus</h3>
                            <p>
                                Stay connected with your team and make quick decisions wherever you are. 
                            </p>
                        </div>
                        <div>
                            <span>
                                <TPSect3Ic2 className="tp-s3-ic" />
                            </span>
                            <h3>Course creation tips</h3>
                            <p>
                                A tool that lets you build a dream website even 
                                if you know nothing about web design or programming.
                            </p>
                        </div>
                    </div>
                    <figure>
                    <img src={TPSect3Ill} alt="" />
                    </figure>
                    <div>
                        <div>
                            <span>
                                <TPSect3Ic3 className="tp-s3-ic" />
                            </span>
                            <h3>Presentation slides</h3>
                            <p>
                                Get a complete sales dashboard in the cloud. 
                                See activity, revenue and social metrics all in one place.
                            </p>
                        </div>
                        <div>
                            <span>
                                <TPSect3Ic4 className="tp-s3-ic" />
                            </span>
                            <h3>Course management</h3>
                            <p>
                                The first business platform to bring together all of your products from one place.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Sect3;